<app-select-input
    [form]="form"
    id="organization"
    [infiniteScroll]="store.organizationScroll()"
    valueKey="id"
    labelKey="name"
    dataKey="id"
    [showLabel]="false"
    [showClear]="false"
    filterBy="name"
    [appendTo]="undefined"
    [autoFocus]="true"
    (selectionChange)="organizationSelected($event)"
></app-select-input>
